import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import { components } from 'apiTyped/types';
import moment from 'moment';

import { parsePreviewArticle } from 'utils/parser';

const isMobile = window.innerWidth < 845;

type MainArticleProps = {
  article: components['schemas']['Post'];
  showBody: boolean;
};

const MainArticle = ({
  article: { id, category, content, is_read },
  showBody = true
}: MainArticleProps) => {
  const { title, pubdate, source, body } = content;

  return (
    <>
      <h3
        className="mainArticleCategory"
        style={{ color: is_read ? 'gray' : 'black' }}
      >
        {category}
      </h3>
      <Link to={`article/${id}/`}>
        <h1
          className="mainArticleTitle linkArticle"
          style={{ color: is_read ? 'gray' : 'black' }}
        >
          {title}
        </h1>
      </Link>
      <div className="mainArticleInfo">
        {moment(pubdate).format('DD MMMM YYYY')}&nbsp;
        {I18n.t('media.fromSource')}&nbsp;<span>{source.name}</span>
      </div>
      {body && showBody && !isMobile && (
        <p className="mainArticleText">{parsePreviewArticle(body)}</p>
      )}
      {showBody && (
        <Link to={`article/${id}/`}>
          <p className="linkArticle underline">{I18n.t('media.readArticle')}</p>
        </Link>
      )}
    </>
  );
};

export default MainArticle;
